import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Tags } from 'apps/tag';

import { TagsListWrapper } from 'apps/project/views/tagsList.styles';

const TagsList = observer(props => {
  const { app, buttonDataTestId, wrapperDataTestId } = props;
  return (
    <TagsListWrapper data-testid={wrapperDataTestId}>
      <Tags
        type='Skills'
        buttonDataTestId={buttonDataTestId}
        tags={app.tags}
        app={app}
        mobileCentered
      />
    </TagsListWrapper>
  );
});

TagsList.propTypes = {
  app: PropTypes.object,
  buttonDataTestId: PropTypes.string,
  wrapperDataTestId: PropTypes.string,
};

export default TagsList;
